import { useMemo, type ReactNode } from 'react';

import { FormFieldTextsProvider } from '@skillarea/lib-frontend';
import { useTranslation } from 'react-i18next';

export function FormFieldTextsBridge({ children }: { children: ReactNode }) {
  const { t } = useTranslation('common');

  const texts = useMemo(
    () => ({
      fieldRequired: t('fieldRequired'),
    }),
    [t],
  );

  return (
    <FormFieldTextsProvider texts={texts}>{children}</FormFieldTextsProvider>
  );
}
